<template>
    <div class="irepoter-post-gallery-slick container" ref="ireport-post">
        <div class="container" v-for="(img, index) in images">
            <div>
                <img :src="img.path_url" alt="images" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            default: () => ({})
        }
    },
    data() {
        return {
            slickOptions: {
                slidesToShow: 3
                // Any other options that can be got from plugin documentation
            }
        };
    },
    created() {},
    mounted() {
        var $window = $(window),
            $card = $(".irepoter-post-gallery-slick"),
            toggleSlick;

        toggleSlick = function() {
            if ($card.hasClass("slick-initialized") == false) {
                $card.slick({
                    rtl: true,
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false
                });
            }
        };
        toggleSlick();
    }
};
</script>
